import { createFileRoute } from '@tanstack/react-router'
import RoyaltyReportsContainer from 'Royalty/containers/RoyaltyReportsContainer'

export const Route = createFileRoute('/royalty/reports')({
    component: RoyaltyReportsContainer,
})
